var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 9.49991V13.4999M12.0003 16.4V16.5M5.39936 19.9999H18.6013C20.1263 19.9999 21.0902 18.3617 20.3496 17.0286L13.7486 5.14688C12.9866 3.77526 11.014 3.77526 10.252 5.14688L3.65105 17.0286C2.91046 18.3617 3.87439 19.9999 5.39936 19.9999Z",
    stroke: "#785200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWarningTriangle;